import { Request } from "@/plugin/axios";
import api from "@/constant/api/company";

export function companyInfoAdd(data) {
  return Request(api.companyInfoAdd, api.companyInfoAdd.url, data);
}
